import axios from 'axios';
import {AuthModel, loggedUserModel} from './_models';

const API_URL = process.env.REACT_APP_API_URL;

export const GET_USER_BY_ACCESSTOKEN_URL = `${API_URL}/me`;
export const OTP_REQUEST = `${API_URL}/otp-auth/initiate`;
export const OTP_VERIFY = `${API_URL}/otp-auth/verify`;

export function initiateOTP(
  public_key: string,
  otp_methods = ['whatsapp', 'email']
) {
  return axios
    .post<{session: string}>(OTP_REQUEST, {
      public_key,
      otp_methods,
    })
    .then((res) => res.data);
}

export function verifyOtp(
  public_key: string,
  private_key: string,
  session: string
) {
  return axios
    .post<AuthModel[]>(OTP_VERIFY, {
      public_key,
      private_key,
      session,
    })
    .then((res) => res.data);
}

export function getUserByToken() {
  return axios.get<loggedUserModel>(GET_USER_BY_ACCESSTOKEN_URL);
}
